import { render } from "./FullscreenButton.vue?vue&type=template&id=40c96874&ts=true"
import script from "./FullscreenButton.vue?vue&type=script&lang=ts"
export * from "./FullscreenButton.vue?vue&type=script&lang=ts"

import "./FullscreenButton.vue?vue&type=style&index=0&id=40c96874&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__